<template>
    <div class="full-cut-detail-wrap">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <h2>{{activeName || '新建'}}</h2>
        </div>
        <el-tabs v-model="tabSel" tab-position="top" type="border-card">
            <el-tab-pane label="活动编辑" name="tab0">
                <activeEdit></activeEdit>
            </el-tab-pane>

            <el-tab-pane v-if="showFitActivePic()" label="活动图片" name="tab1">
                <activePicture></activePicture>
            </el-tab-pane>
            <el-tab-pane v-if="!showFitActivePic()" label="上传图片" name="tab2">
                <pictureM></pictureM>
            </el-tab-pane>
            <!--<el-tab-pane v-if="activeType==0&&activeNo!=''" label="图片链接" name="tab2">-->
            <!--<activeProperty></activeProperty>-->
            <!--</el-tab-pane>-->
            <el-tab-pane v-if="getGrouponShow(activeType)&&activeNo!=''" label="团购配置" name="tab3">
                <groupPurchaseConfig></groupPurchaseConfig>
            </el-tab-pane>

            <el-tab-pane v-if="activeNo!=''" label="优惠券" name="tab4">
                <el-row :gutter="20">
                    <activeCoupon></activeCoupon>
                </el-row>
                <el-row :gutter="20">
                    <activeCouponRule></activeCouponRule>
                </el-row>
            </el-tab-pane>
            <el-tab-pane v-if="activeNo!=''" label="二维码" name="tab5">
                <activeQrMangement></activeQrMangement>
            </el-tab-pane>

            <el-tab-pane v-if="activeNo!=''" label="规则" name="tab6">
                <activeRule></activeRule>
            </el-tab-pane>
            <el-tab-pane v-if="activeNo!=''" label="页面配置" name="tab7">
                <pageConfig></pageConfig>
            </el-tab-pane>
            <el-tab-pane v-if="activeNo!=''&&activeType==9" label="打卡次数和提醒" name="tab8"> <!--  v-if="activeType==9"-->
                <checkInConfig></checkInConfig>
            </el-tab-pane>
            <el-tab-pane label="活动属性" name="tab9"> <!--  v-if="activeType==9"-->
                <inviteGiftProperty></inviteGiftProperty>
            </el-tab-pane>
            <el-tab-pane v-if="activeNo!=''&&(activeType==43||activeType==45||activeType==50||activeType==53)" label="活动商品"
                         name="tab10"> <!--  v-if="activeType==9"-->
                <activeProductList></activeProductList>
            </el-tab-pane>
            <el-tab-pane v-if="activeNo!=''&&(activeType==50)" label="折扣管理"
                         name="tab11"> <!--  v-if="activeType==9"-->
                <activeCutRule></activeCutRule>
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import activeEdit from '@/views/active/activeEdit'
    import activeCoupon from '@/components/coupon/coupon'
    import activeCouponRule from '@/components/coupon/couponRule'
    import pictureM from '@/components/picture'
    import activeQrMangement from '@/views/active/activeQrMangement'
    import activeRule from '@/views/active/activeRule'
    import pageConfig from "@/views/active/pageConfig";
    import activeProperty from "@/views/active/activeProperty";
    import groupPurchaseConfig from "@/views/active/groupPurchaseConfig";
    import checkInConfig from "./checkInConfig";
    import inviteGiftProperty from "@/views/active/inviteGiftPropertyList";
    import activePicture from "@/views/active/activePicture";
    import activeProductList from "@/views/active/activeProductList";
    import activeCutRule from "@/views/active/activeCutRule";
    //定义组件
    export default {
        data() {
            return {
                tabSel: this.$route.query.curTab || 'tab0',
                activeNo: this.$route.query.activeNo,
                bindCode: this.$route.query.bindCode,
                activeType: this.$route.query.activeType || 0,
                activeName: this.$route.query.activeName,
            }
        },
        components: {
            activeEdit,
            activeCoupon,
            activeCouponRule,
            pictureM,
            activeQrMangement,
            activeRule,
            pageConfig,
            activeProperty,
            groupPurchaseConfig,
            checkInConfig,
            inviteGiftProperty,
            activeCutRule,
            activeProductList,
            activePicture
        },
        methods: {
            returnHistory(){
                window.history.back()
            },
            getGrouponShow(activeType){
                return activeType == 23;
            },
            showFitActivePic(){
                return this.activeType == 19 || this.activeType == 22;
            },
        },
        watch: {
            '$route'(to, from) {
                // 对路由变化作出响应...
                console.log("路由变了")
                if (this.$route.query.activeNo != '') {
                    console.log("路由变了reload")
                    location.reload();
                }
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .full-cut-detail-wrap {
        padding: 10px;
        .header-return {
            //margin-bottom: 20px;
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 10px;
            position: relative;
            h2 {
                text-align: center;
                position: absolute;
                left: 50%;
                top: 0;
                margin: 0;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/views/active/activetabs.vue